import { useEffect, useRef, useState } from "react";

function initializeSeasonDates(activeSeason, handleFilterChange) {
	if (activeSeason.start_date) {
		handleFilterChange("date_start", activeSeason.start_date);
	}
	if (activeSeason.end_date) {
		handleFilterChange("date_end", activeSeason.end_date);
	}
}

export function useOAFilters({ lookups, filtersState, setFilterOptions, handleFilterChange, handleApplyFilters, showInternalCode, skipAutoDateInit = false }) {
	const lastSeasonIdRef = useRef(null);
	const seasonInitializedRef = useRef(false);
	const [pendingApply, setPendingApply] = useState(false);
	const [isReady, setIsReady] = useState(false);

	useEffect(() => {
		if (!lookups) return;

		if (lookups.business) setFilterOptions("business_id", lookups.business, false);
		if (lookups.states) setFilterOptions("status", lookups.states, false);
		if (lookups.types) setFilterOptions("type", lookups.types, false);

		setFilterOptions("internal_code", [], showInternalCode);

		if (!lookups.seasons) {
			setIsReady(true);
			return;
		}

		setFilterOptions("season_id", lookups.seasons, false);

		if (seasonInitializedRef.current || !handleFilterChange) return;

		const activeSeason = lookups.seasons.find((s) => s.active === true || s.active === 1);

		if (!activeSeason) {
			seasonInitializedRef.current = true;
			setIsReady(true);
			return;
		}

		handleFilterChange("season_id", activeSeason.value);
		if (!skipAutoDateInit) {
			initializeSeasonDates(activeSeason, handleFilterChange);
		}
		seasonInitializedRef.current = true;
		setPendingApply(true);
	}, [lookups, setFilterOptions, handleFilterChange, showInternalCode, skipAutoDateInit]);

	useEffect(() => {
		if (!pendingApply || !handleApplyFilters || !filtersState) return;

		const seasonFilter = filtersState.find((f) => f.key === "season_id");
		const dateStartFilter = filtersState.find((f) => f.key === "date_start");

		if (seasonFilter?.value && (skipAutoDateInit || dateStartFilter?.value)) {
			handleApplyFilters();
			setPendingApply(false);
			setIsReady(true);
			lastSeasonIdRef.current = seasonFilter.value;
		}
	}, [pendingApply, filtersState, handleApplyFilters, skipAutoDateInit]);

	useEffect(() => {
		if (!lookups?.seasons || !filtersState || !handleFilterChange) return;
		if (!seasonInitializedRef.current || pendingApply) return;

		const seasonFilter = filtersState.find((f) => f.key === "season_id");
		const currentSeasonId = seasonFilter?.value;

		if (currentSeasonId === lastSeasonIdRef.current) return;
		lastSeasonIdRef.current = currentSeasonId;

		if (!currentSeasonId) return;

		const selectedSeason = lookups.seasons.find((s) => String(s.value) === String(currentSeasonId));

		if (!selectedSeason) return;
		if (skipAutoDateInit) return;

		initializeSeasonDates(selectedSeason, handleFilterChange);
	}, [lookups?.seasons, filtersState, handleFilterChange, pendingApply, skipAutoDateInit]);

	return { isReady };
}
